import { axiosInstance } from 'boot/axios';

export function getCollectivity({ commit }) {
  return axiosInstance.get('Collectivity').then((response) => {
    if (response.status === 200) {
      commit('setCollectivity', response.data);
    }
  });
}
